
import React, { useEffect, useRef } from "react";

const CareerOpportunities = () => {
  const careers = [
    {
      title: "The Next Step in Your Career Starts Here.",
      description:
        "At ENVISION, experience drives experience. Experienced professionals will join a community of people who are shaping the future with technology. Our skills, expertise and perspectives will help reshape our business with industry-leading technology services and human insight, unlocking innovation and value for our clients. Do your best work in an environment that will supercharge the industry and your career.",
      img: "/image/CAREER1.webp",
    },
    {
      title: "From College to Career in a Single Spark.",
      description:
        "Careers are not built by simply landing a job; they're built by finding a job that fuels your spark and supercharges your potential. ENVISION students should help you find your spark and shape your career. At ENVISION, 3,000+ interns discover new opportunities, choose career paths and ignite innovation across industries at the center of technology, innovation and personal and professional growth.",
      img: "/image/CAREER3.jpg",
    },
    {
      title: "High School Career Launcher.",
      description:
        "As an aspiring tech professional, you shouldn't have to wait until college to supercharge your future. Our Early Career Program creates career pathways for high school-aged students, delivering comprehensive technical instruction, hands-on skills development, and wraparound support. The program also matches motivated learners to open opportunities in the tech industry, plus enables success in higher education. That's right, you can accelerate into the career you've envisioned or education with financial support from ENVISION.",
      img: "/image/CAREER4.jpg",
    },
    {
      title: "Taking a Break From Work Shouldn't Break Your Career.",
      description:
        "As you mature in the industry, career breaks are often necessary. If you're provided the right environment, they can lead to even greater accomplishments. Our Relaunch Program empowers candidates who are returning after work or caregiving breaks. With our 'TechBee' training and mentoring arms, matching you with the perfect job and making sure every restart truly feels like the beginning of a long and rewarding journey with us.",
      img: "/image/CAREER5.jpg",
    },
  ];

  // refs for animation
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.2 }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      cardsRef.current.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  return (
    <div style={{
      padding: "60px 20px",
      fontFamily: "Arial, sans-serif",
      width: "100%",
      backgroundColor: "white",
    }}>
      <div style={{
        maxWidth: "1200px",
        margin: "0 auto",
      }}>
        <h2 style={{
          textAlign: "center",
          fontSize: "32px",
          marginBottom: "50px",
          fontWeight: "700",
          color: "black",
          letterSpacing:"0px",
        }}>A Career Opportunity for Everyone</h2>
        
        {careers.map((career, index) => (
          <div
            key={index}
            ref={(el) => (cardsRef.current[index] = el)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "40px",
              background: "white",
              borderRadius: "12px",
              marginBottom: "60px",
              padding: "15px",
              flexWrap: "wrap",
              opacity: "0",
              transform: "translateY(50px)",
              transition: "all 0.8s ease-out",
              boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
              flexDirection: index % 2 === 0 ? "row" : "row-reverse",
            }}
          >
            <div style={{
              flex: "1 1 300px",
              minWidth: "280px",
              display: "flex",
              justifyContent: "center",
            }}>
              <img 
                src={career.img} 
                alt={career.title} 
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  borderRadius: "10px",
                  objectFit: "cover",
                  height: "280px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }} 
              />
            </div>
            
            <div style={{
              flex: "1 1 500px",
              padding: "10px",
            }}>
              <h3 style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#fff",
                background: "#025261",
                padding: "12px 20px",
                borderRadius: "8px",
                marginBottom: "20px",
                display: "inline-block",
                lineHeight: "1.3",
              }}>{career.title}</h3>
              <p style={{
                fontSize: "16px",
                color: "#444",
                lineHeight: "1.7",
                textAlign: "justify",
              }}>{career.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareerOpportunities;